
import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TriggerEnrichmentPayload {
  client_id?: string;
  lead_id?: string;
  company_name: string;
  company_website?: string;
}

// Add missing fields to EnrichmentResponse interface to match database records
export interface EnrichmentResponse {
  id?: string;
  lutra_run_id?: string;
  client_id?: string;
  status?: string;
  progress_stage?: string;
  error_message?: string;
  result_data?: unknown;
  debug?: {
    lutraWebhookResponse?: unknown;
    [key: string]: unknown;
  };
  estimated_completion_at?: string;
  created_at?: string;
  updated_at?: string;
  poll_attempts?: number;
  requested_at?: string;
  completed_at?: string;
  processing_started_at?: string;
  next_poll_at?: string;
  priority?: string;
  user_id?: string;
  enriched_data?: unknown;
  lutra_results_url?: string;
  workflow_input?: unknown;
  run_id?: string;
  message?: string;
  details?: string;
}

export const useCompanyEnrichment = () => {
  const triggerEnrichmentMutation = useMutation({
    mutationFn: async (payload: TriggerEnrichmentPayload): Promise<EnrichmentResponse> => {
      const { data, error } = await supabase.functions.invoke('lutra-enrichment-webhook', {
        body: payload
      });

      if (error) {
        throw new Error(error.message || 'Failed to trigger enrichment');
      }

      return data as EnrichmentResponse;
    },
  });

  return {
    triggerEnrichmentMutation: triggerEnrichmentMutation.mutateAsync,
    isPending: triggerEnrichmentMutation.isPending,
    error: triggerEnrichmentMutation.error,
  };
};
